<div [formGroup]="form"
     class="flex-col gap-16 form">
    <div class="flex-col gap-8">
        <label>{{ 'COMMON.NAME'|translate }} <span class="required">*</span></label>
        <input class="ui-input ui-input-40"
               formControlName="name">
    </div>

    <div class="flex-col gap-8">
        <label>{{ 'FLOW_CHART.TIMEOUT_S'|translate }} <span class="required">*</span></label>
        <input formControlName="timeoutS"
               class="ui-input ui-input-40"
               type="number" 
               min="0"/>
    </div>
</div>